import React from 'react';
import { useSettingsStore } from '../../stores/settingsStore';
import { DEFAULT_GRAPH_SETTINGS } from '../../services/settingsService';
import * as styles from '../../styles/components/settings-modal.css';

/**
 * グラフ設定コンポーネント
 * Graph Builder関連のグローバル設定UIを提供
 */
export function GraphSettings() {
  const graphSettings = useSettingsStore((state) => state.settings.graph);
  const updateGraphSettings = useSettingsStore((state) => state.updateGraphSettings);

  const handleMaxFacetCategoriesChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseInt(e.target.value, 10);
    if (!isNaN(value) && value >= 1 && value <= 100) {
      updateGraphSettings({ maxFacetCategories: value });
    }
  };

  const handleReset = () => {
    updateGraphSettings({ ...DEFAULT_GRAPH_SETTINGS });
  };

  return (
    <div className={styles.section}>
      <h3 className={styles.sectionTitle}>Facet Settings</h3>
      <p className={styles.sectionDescription}>
        Configure limits for faceted graphs to prevent performance issues.
      </p>

      <div className={styles.settingRow}>
        <label className={styles.settingLabel} htmlFor="maxFacetCategories">
          Max Facet Categories
        </label>
        <input
          id="maxFacetCategories"
          type="number"
          min="1"
          max="100"
          className={styles.numberInput}
          value={graphSettings.maxFacetCategories}
          onChange={handleMaxFacetCategoriesChange}
          data-testid="max-facet-categories-input"
        />
      </div>

      <div className={styles.infoBox}>
        <strong>Note:</strong> Columns with more categories than this limit will be disabled
        in the Facet variable dropdown. This prevents creating too many graph panels which
        can cause browser freezing.
      </div>

      <div className={styles.resetSection}>
        <button
          className={styles.resetButton}
          onClick={handleReset}
          data-testid="reset-graph-settings-button"
        >
          Reset to Defaults
        </button>
      </div>
    </div>
  );
}
